import React from 'react';

const ServiceMeshIstio = () => (
  <div className="py-16 bg-gradient-to-b from-gray-50 to-gray-100 min-h-screen">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-5xl md:text-6xl font-extrabold text-gray-800 mb-8" data-aos="fade-up">
          Service Mesh (Istio)
        </h1>
        <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-l-4 border-blue-600" data-aos="fade-up" data-aos-delay="100">
          <p className="text-lg text-gray-700 mb-6">
            A <strong>service mesh</strong> is an infrastructure layer that manages service-to-service communication in a microservices architecture. <strong>Istio</strong> is one of the most popular service mesh solutions, providing traffic management, security, and observability for distributed applications.
          </p>
          <h2 className="text-2xl font-bold text-blue-700 mb-4 mt-8">How Istio Works</h2>
          <p className="mb-4 text-gray-700">
            Istio uses a sidecar proxy pattern (typically with Envoy) injected alongside application containers. These proxies intercept all network traffic between services, enabling powerful features like:
          </p>
          <ul className="list-disc ml-8 mb-6 text-gray-700">
            <li><strong>Traffic Management:</strong> Fine-grained control over routing, load balancing, and canary deployments.</li>
            <li><strong>Security:</strong> Automatic mTLS encryption, authentication, and authorization between services.</li>
            <li><strong>Observability:</strong> Metrics, distributed tracing, and logging for deep visibility into service interactions.</li>
          </ul>
          <h2 className="text-2xl font-bold text-blue-700 mb-4 mt-8">Organizational Benefits</h2>
          <ul className="list-disc ml-8 mb-6 text-gray-700">
            <li>Simplifies application networking and security</li>
            <li>Enables safe, progressive delivery of new features</li>
            <li>Provides end-to-end visibility for troubleshooting and optimization</li>
            <li>Improves compliance and governance with policy enforcement</li>
          </ul>
          <p className="text-gray-700">
            Organizations can leverage Istio to accelerate their cloud-native journey, reduce operational complexity, and build more resilient systems.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default ServiceMeshIstio;
